import { Institution, InstitutionFlag, InstitutionSource } from '~/types/institution';

export const isSwanInstitution = (institution: Institution) => institution.source === InstitutionSource.SWAN;
export const isYapilyInstitution = (institution: Institution) => institution.source === InstitutionSource.YAPILY;
export const isSdiCoopInstitution = (institution: Institution) => institution.name === 'Cassetto Fiscale SDI';
export const isEntratelInstitution = (institution: Institution) => institution.name === 'Cassetto Fiscale';
export const isMockInstitution = (institution: Institution) => institution.name === 'Mock accounting adapter';
export const hasPaymentsFlag = (institution: Institution) => institution.flags.includes(InstitutionFlag.PAYMENTS);
export const hasInstantPaymentsFlag = (institution: Institution) =>
  institution.flags.includes(InstitutionFlag.INSTANT_PAYMENTS);
export const hasScheduledPaymentsFlag = (institution: Institution) =>
  institution.flags.includes(InstitutionFlag.SCHEDULED_PAYMENTS);
export const hasBulkPaymentsFlag = (institution: Institution) =>
  institution.flags.includes(InstitutionFlag.BULK_PAYMENTS);
